/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const entity = {
  name: {},
  description: {},
  discount: {},
  img: {},
  code: {},
  type: {},
  startTime: {},
  endTime: {},
  usefulTime: {}
}
const config = {
  load: async function (filter) {
    return [{ name: '疯狂星期四', description: '我秦始皇,V50', discount: '20', img: '', code: '123465', type: '直推', startTime: '2024-02-07 00:00:00', endTime: '2024-02-10 23:59:59', usefulTime: 2 },
      { name: '劲爆半价', description: '跳楼大甩卖', discount: '50', img: '', code: '654321', type: '推荐', startTime: '2024-02-10 00:00:00', endTime: '2024-02-12 23:59:59', usefulTime: 2 }
    ]
  }
}
export default IKDataEntity.ModelFactory(entity, config)
